//LOGO
export const LOGO = '/assets/svg/logo.svg'
export const LOGO_WHITE = '/assets/svg/logoWhite.svg'
export const LOGO_WHITE_ORANGE = '/assets/svg/logoWhiteOrange.svg'
export const LOGO_PNG = '/assets/svg/logoPng.png'
export const LOGO_WHITE_PNG = '/assets/png/logoWhitePng.svg'
export const SITE_NAME = 'NPS Auctions'
